

import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom"; // Import useNavigate
import DashboardSidebar from './DashboardSidebar';
import DashboardNavbar from "../DashboardNavbar";
import DashboardAnalytics from "../../pages/StudentsPortal/DashboardAnalytics";
import UploadedEssays from "../../pages/StudentsPortal/UploadedEssays";
import Profile from "../../pages/StudentsPortal/Profile";
import Complain from '../../pages/StudentsPortal/Complain';
import EssayDetails from '../../pages/StudentsPortal/EssayDetails'; // Import EssayDetails

const DashboardStudentPortal = () => {
  const [selectedMainComponent, setSelectedMainComponent] = useState('Dashboard');

  // Function to render the selected main component
  const renderMainComponent = () => {
    switch (selectedMainComponent) {
      case 'Dashboard':
        return <DashboardAnalytics />;
      case 'Upload Essays':
        return <UploadedEssays />;
      case 'Complains':
        return <Complain />;
      case 'Settings':
        return <Profile />;
      default:
        return <DashboardAnalytics />;
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <div className="sidebarwidth">
        <DashboardSidebar setSelectedMainComponent={setSelectedMainComponent} />
      </div>
      <div style={{ width: "83%" }}>
        <DashboardNavbar />
        <Routes>
          <Route path="/" element={renderMainComponent()} />
          <Route path="essay-details" element={<EssayDetails />} /> {/* Add Route for EssayDetails */}
        
        </Routes>
      </div>
    </div>
  );
};

export default DashboardStudentPortal;
